export const APP_STORE_BADGE_ASSETS = {
  en: '/badges/stores/en-app-store-badge.svg',
  fr: '/badges/stores/fr-app-store-badge.svg',
  es: '/badges/stores/es-app-store-badge.svg',
  de: '/badges/stores/de-app-store-badge.svg',
  it: '/badges/stores/it-app-store-badge.svg',
};

export const GOOGLE_PLAY_BADGE_ASSETS = {
  en: '/badges/stores/en-google-play-badge.svg',
  fr: '/badges/stores/fr-google-play-badge.svg',
  es: '/badges/stores/es-google-play-badge.svg',
  de: '/badges/stores/de-google-play-badge.svg',
  it: '/badges/stores/it-google-play-badge.svg',
};
